// extracted by mini-css-extract-plugin
module.exports = {"button":"button1_button__2tFD-"};